<script>
export default {
  name: "aboutUsContent",
  data() {
    return {};
  },
  beforeUpdate() {
    document.title = "UNIFI Property: About Us";
  },
  methods: {}
};
</script>

<template>
  <el-row
    style="padding: 30px 15px 30px 15px; background-color: #fff; margin: 0"
  >
    <el-col :span="24">
      <el-row>
        <el-col :span="24">
          <span class="about-unifi-title">About UNIFI Property</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 16px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400"
            >UNIFI Property is a forward-thinking platform designed for off-the-plan real estate, aimed at transforming how new properties are marketed and sold. Founded by siblings Loretta and Michael Cavallaro, who bring 24 years of combined experience as off-the-plan real estate specialists in South Australia and Victoria, the platform is built on the principles of integrity, transparency, and innovation.
          </span>
          <br />
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400"
            >Recognizing a crucial gap in the traditional real estate market, where off-the-plan properties required a unique marketing approach that standard open inspections couldn't address, they envisioned a platform offering an immersive online experience. This would enable potential buyers to thoroughly explore new properties before committing to a purchase.
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12"
            >UNIFI Property was first launched as a B2B platform in August 2020, catering to real estate agents looking to showcase their clients' projects. As the platform gained momentum, Loretta and Michael saw an opportunity to expand its services directly to consumers. After three years of focused development, UNIFI Property was reintroduced in March 2024 as a public platform, providing a next-generation solution that enhances the buying and selling process for off-the-plan properties.
          </span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.about-unifi-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.about-unifi-para {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 125%;
}
.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #fff;
  color: #003333;
}
.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #2d2d2d;
}
.el-collapse-item /deep/ .el-collapse-item__content {
  color: #003333;
}
.font-w400 {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/about/aboutUsContent.vue